const daysInMonth = (m, y) => {
  switch (m) {
    case 1:
      return (y % 4 == 0 && y % 100) || y % 400 == 0 ? 29 : 28;
    case 8:
    case 3:
    case 5:
    case 10:
      return 30;
    default:
      return 31;
  }
};

export const isValidDate = (d, m, y) => {
  return m >= 0 && m < 12 && d > 0 && d <= daysInMonth(m, y);
};

export const getAgeFromDob = dob => {
  var birthday = +new Date(dob);
  return ~~((Date.now() - birthday) / 31557600000);
};
export function getAgeFromDateString(dateString) {
  const ageDifMs = Date.now() - new Date(dateString).getTime();
  const ageDate = new Date(ageDifMs);

  return Math.abs(ageDate.getUTCFullYear() - 1970);
}



// WEBPACK FOOTER //
// ./src/utils/date.ts